import React, { Component } from 'react';
import cx from 'classnames';
import _get from 'lodash.get';
import { credentials } from '@shootsta/client-auth';
import { replaceBucketKeysWithUrls } from '@shootsta/client-aws-s3';

import { Icon, Image, MenuButton, Text, NavigationMenuMobile, NUMERIC_MEDIA_SIZES } from '../../../ui-kit';

import ProfileMenu from './ProfileMenu';
import MenuItem from './MenuItem';
import { redirectToSingleLogout, getSSOLocalStore, clearSSOLocalStore } from '../utils';
import '../styles/_app-switcher-header.scss';






























export default class AppSwitcherHeader extends Component


{
  constructor(props) {
    super(props);

    const { userId, firstName, lastName } = _get(credentials.get(), 'user', {});
    const { original = null, origURL = '' } = credentials.get();
    credentials.listenToChange(this.handleCredentialsChange);

    const fullName = `${firstName} ${lastName}`;

    this.state = {
      userId,
      fullName,
      imageUrl: void 0,
      isGhosting: Boolean(original),
      original,
      origURL
    };
  }

  componentDidMount() {
    this.getPreSignedImageUrl();
  }

  getPreSignedImageUrl = async () => {
    const { organisationId, apolloClient } = this.props;
    const { imageUrl } = _get(credentials.get(), 'user', {});

    try {
      const { imageUrl: preSignedImageUrl } = await replaceBucketKeysWithUrls({
        apiClient: apolloClient,
        data: { imageUrl },
        substitutedKeys: ['imageUrl'],
        organisationId
      });

      this.setState({ imageUrl: preSignedImageUrl });
    } catch {

      // Silently handle error
    }};

  handleCredentialsChange = (userCredentials) => {
    if (!userCredentials || !userCredentials.user) {
      return;
    }
    const { user } = userCredentials;
    this.setState({
      ...user,
      fullName: `${user.firstName} ${user.lastName}`
    }, this.getPreSignedImageUrl);
  };

  handleSignOut = () => {
    const { ssoEnabled } = getSSOLocalStore();
    const { isGhosting } = this.state;

    clearSSOLocalStore();

    // If ghosting or not ssoEnabled, show HUB login page
    if (!ssoEnabled || isGhosting) {
      return void credentials.clear();
    }

    const { history } = this.props;

    history.push({ search: '?redirecting=true' });
    credentials.clear();

    return void redirectToSingleLogout();
  };

  handleStopGhosting = () => {
    const { history } = this.props;
    const {
      original: originalData,
      origURL: targetURL
    } = this.state;
    const { token, user, original = null } = originalData || {};

    clearSSOLocalStore();

    history.push(
      `/?ghost=${btoa(JSON.stringify({ clearGhost: true, token, user, original, targetURL }))}`
    );
  };

  goToHome = () => {
    const { history } = this.props;

    history.push('/');
  };

  getNavRoutes = (navRoutes) => {
    const { history } = this.props;

    if (!navRoutes || !navRoutes.length) {
      return [];
    }

    return navRoutes.map(({ url = '', onClick, subMenuRoutes, ...other }) => ({
      ...other,
      onClick: onClick || (() => history.push(url)),
      subMenuRoutes: subMenuRoutes && Array.isArray(subMenuRoutes) ?
      this.getNavRoutes(subMenuRoutes) :
      void 0
    }));
  };

  render() {
    const {
      className,
      history,
      notificationsButton,
      isAdministration,
      organisationImageUrl,
      organisationName,
      width,
      primaryButtonProps,
      navRoutes,
      mobileNavRoutes,
      profileMenuContent,
      primaryColour,
      primaryLinksColour,
      additionalRightContent,
      primaryLinksSelectedColour
    } = this.props;
    const { userId, imageUrl, fullName, isGhosting } = this.state;

    const isMobile = width < NUMERIC_MEDIA_SIZES.small;
    const navRouteItems = this.getNavRoutes(isMobile ? mobileNavRoutes : navRoutes);

    return (
      <header
        className={cx('app-switcher-header', className, {
          'app-switcher-header__mobile': isMobile
        })}>

        {
        !isMobile ?
        <>
              <MenuButton
            id="navigation-menu"
            closeAfterClick
            customButton={
            <Icon
              tooltipId="more-apps-menu"
              tooltipLabel="More Apps"
              tooltipPlace="bottom"
              name="apps"
              size={24} />}>



                {navRouteItems.map((item) =>
            <MenuItem key={item.label} {...item} />
            )}
              </MenuButton>
              <button
            type="button"
            onClick={this.goToHome}
            className="app-switcher-header__organisation-btn">

                {
            organisationImageUrl ?
            <Image width="35px" height="35px" imageUrl={organisationImageUrl} backgroundSize="cover" /> :
            <Icon name="shootstacolour" size={35} />}

                <Text heading4 noMargin>{organisationName || 'Shootsta'}</Text>
              </button>
              {isAdministration &&
          <Text className="app-switcher-header__administration">Administration</Text>}

            </> :

        <NavigationMenuMobile
          history={history}
          topRoutes={navRouteItems}
          isExpandable
          logoUrl={imageUrl}
          primaryButtonProps={primaryButtonProps}
          primaryColour={primaryColour}
          primaryLinksColour={primaryLinksColour}
          primaryLinksSelectedColour={primaryLinksSelectedColour} />}



        <div className="app-switcher-header__right-panel">
          {additionalRightContent}
          {
          !isMobile ?
          <>
                <div id="nav-item-livesupport">
                  <Icon name="livechat" size={20} />
                </div>
                <Icon
              name="faq"
              size={20}
              onClick={() => window.open('https://help.shootsta.com/en', '_blank')} />

              </> :
          notificationsButton}

          <div className="app-switcher-header__profile-btn">
            <ProfileMenu
              history={history}
              imageUrl={imageUrl}
              fullName={fullName}
              userId={userId}
              handleSignOut={this.handleSignOut}
              handleStopGhosting={this.handleStopGhosting}
              isGhosting={isGhosting}
              profileMenuContent={profileMenuContent} />

          </div>
        </div>
      </header>);

  }
}